import React, { useState } from 'react'
import styled from 'styled-components'
import Modal from 'components/Modal'
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore'
import Button from 'components/Button'
import { restoreTeacher } from 'services/TeachersService'
import { fetchTeachersListRoutine } from 'modules/teachers/ducks/actions'
import { useDispatch } from 'react-redux'

const RestoreTeacherModal = ({ teacher }) => {
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()

  const handleOpen = e => {
    e.stopPropagation()
    setOpen(true)
  }
  const handleClose = e => {
    e && e.stopPropagation()
    setOpen(false)
  }

  const fetchTeachersList = () => {
    dispatch(fetchTeachersListRoutine())
    handleClose()
  }

  const handleRestore = () => {
    restoreTeacher({
      teacher,
      callback: fetchTeachersList
    })
  }

  return (
    <>
      <Trigger onClick={handleOpen}>
        <StyledIcon />
      </Trigger>
      <Modal
        title='Przywróć'
        open={open}
        onClose={handleClose}
      >
        Czy na pewno chcesz przywrócić nauczyciela <TeacherName>{teacher.name}</TeacherName>?
        <ButtonsWrapper>
          <Button onClick={handleClose} color='secondary'>Anuluj</Button>
          <Button color='primary' onClick={handleRestore}>Przywróć</Button>
        </ButtonsWrapper>
      </Modal>
    </>
  )
}

export default RestoreTeacherModal

const Trigger = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`

const StyledIcon = styled(SettingsBackupRestoreIcon)`
  transition: all .3s;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary.main};
  }
`

const TeacherName = styled.span`
  color: ${({ theme }) => theme.colors.secondary.main};
  font-weight: bold;
`

const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`
